module.exports = __webpack_public_path__ + "hero-0.5x-6007acb0164b625985db1995e6cdd3dd.webp";